<template lang="en">
<div class="doctor-profile">
    <Navigation></Navigation>
    
    <Loader :show="loading" type="inline"></Loader>
    <Loader :show="purchasing" ></Loader>

    <div class="container margin_60" v-if="!loading">
        <div class="row">
            
            <aside class="offset-md-1 col-md-10 offset-lg-3 col-lg-6" id="sidebar">
                <div class="box_general_3 booking">
                    <div>
                        <div class="title">
                            <h3>Finalizar reserva</h3>
                        </div>

                        <div class="card-doctor">
                            <figure class="profile-picture">
                                <div class="image" v-if="this.medic.picture" :style="'background-image:url('+API_URL+this.medic.picture.urlThumb+')'"></div>
                                <div class="avatar" v-if="!this.medic.picture && this.medic.gender=='female'" :style="'background-image:url('+require('@/assets/img/no-avatar-image-female.jpg')+')'"></div>
                                <div class="avatar" v-if="!this.medic.picture && this.medic.gender=='male'" :style="'background-image:url('+require('@/assets/img/no-avatar-image-male.jpg')+')'"></div>
                            </figure>
                            <div class="profile-data">
                                <h2>{{this.medic.fullname}}</h2>
                                <div class="subtitle">
                                    <span v-for="especiality in this.medic.medicEspecialities" :key="especiality.id">{{especiality.especiality.name}} </span>
                                </div>

                                <div v-if="this.medic.rate>0">
                                    <star-rating :star-size="14" :read-only="true" :show-rating="false" :rating="this.medic.rate"  inactive-color="#ddd" :inline="true"></star-rating>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="summary">
                            <ul>
                                <li>Fecha: <strong class="float-right">{{ purchase.slot.datetime | moment("dddd DD/MM/YYYY") }}</strong></li>
                                <li>Hora: <strong class="float-right">{{ purchase.slot.datetime | moment("HH:mm") }}</strong></li>
                                <li>Ubicación: 
                                    <strong class="float-right text-right">{{ purchase.address.locality.name }}, {{ purchase.address.locality.region.name}} </strong>
                                </li>
                            </ul>
                        </div>
                        <hr>
                        <ul class="summary">
                            <li class="total">
                                Consulta de {{purchase.especiality.especiality.name}} 
                                <span v-if="purchase.channel == 'video'"> por videollamada</span>
                                <span v-else> presencial</span>

								<strong class="float-right text-success" v-if="purchase.coupon">$ 0 </strong>
								<strong class="float-right" v-if="!purchase.coupon && !couponValidated">$ {{purchase.priceBase}}</strong>
								<span class="float-right text-right" v-if="!purchase.coupon && couponValidated">
									<small class="text-muted" style="text-decoration:line-through;">$ {{purchase.priceBase}}</small><br>
									<span >$ {{purchase.price}}</span>
									
								</span>
                            </li>
                        </ul>
                        <div class="alert alert-sucess alert-sm text-success text-center"  v-if="purchase.coupon">
                            Está realizando una reserva gratuita a traves del sistema gratia 
                        </div>

						<hr>

						<div class="px-3 d-flex align-items-end justify-content-center discount-code">
							<div class="form-group">
								<input type="text" placeholder="Código de descuento" class="form-control" v-model="discountCode">
							</div>
							<div class="form-group">
								<button class="btn btn-primary" v-if="!couponValidated" @click="applyCoupon">Aplicar cupón</button>
								<button class="btn btn-success" v-if="couponValidated" >Cupón aplicado</button>
							</div>
						</div>


                        <hr>
                        <div class="p-3">
                            
                            <div class="alert alert-danger text-center" v-if="!loggedUser.is_completed">
                                Debe completar sus datos personales para poder realizar una reserva.<br><br>
                                <router-link to="/profile" tag="a" class="btn btn-sm btn-danger">Actualizar datos personales</router-link>
                            </div>

                            <Payment 
                                v-if="loggedUser.is_completed && !purchase.coupon"
                                :amount="purchase.price" 
                                :datetime="purchase.slot.datetime"  
                                ref="PaymentComponent" 
                                @paymentDone="paymentDone" 
                                @paymentClosed="paymentClosed" >
                            </Payment>

                            <button class="btn_1 full-width" @click="confirmPurchase()" v-if="!purchasing && purchase.coupon">Confirmar</button>
                            <button class="btn_1 full-width" @click="confirmPurchase()" v-if="!purchasing && !purchase.coupon">Confirmar y pagar</button>
                            <button class="btn_1 full-width" v-if="purchasing">Procesando reserva</button>

                            <p class=" text-center highlight">
                                Una vez que finalices tu reserva te enviamos el detalle y los datos de contacto para tu consulta.
                            </p>

                        </div>


                    </div>
                </div>
                <!-- /box_general -->
            </aside>
            <!-- /asdide -->
        </div>
        <!-- /row -->
    </div>

    <Footer></Footer>

</div>
</template>

<script>
import gql from 'graphql-tag'
import { mapGetters, mapMutations } from 'vuex'

import Navigation from '@/components/Navigation'
import Footer from '@/components/Footer'
import Loader from '@/components/Loader'
import Payment from '@/components/Payment'

export default {
	name: 'Checkout',
	metaInfo: {
		title: 'Finalizar reserva',
	},
	components: {
		Navigation,
		Footer,
		Loader,
		Payment,
	},
	computed: {
		...mapGetters(['isAuthenticated', 'loggedUser', 'purchase']),
	},
	data() {
		return {
			API_URL: process.env.VUE_APP_API_URL,
			loading: true,
			purchasing: false,
			medic: {},
			bookingCode: null,
			discountCode: '',
			couponValidated: false
		}
	},
	beforeMount() {
		console.log('stored purchase', this.purchase)
		if (
			!this.purchase.especiality ||
			this.purchase.especiality.id <= 0 ||
			!this.purchase.slot ||
			this.purchase.slot.id <= 0 ||
			!this.isAuthenticated
		) {
			this.$router.go(-1)
		}
		this.purchase.price = this.purchase.priceBase
	},
	mounted() {
		this.loadMedic()
	},
	methods: {
		...mapMutations(['removePurchase','storePurchase']),

		applyCoupon(){
			this.couponValidated = false
			if( this.discountCode == 'CUPONSTAR' ){
				this.couponValidated = true
				this.purchase.couponCode = this.discountCode
				this.purchase.price = this.purchase.priceBase * 0.8
				this.storePurchase(this.purchase)
			}
		},

		loadMedic() {
			this.$apollo
				.query({
					query: gql`
						query getMedic($id: ID!) {
							medic(id: $id) {
								id
								fullname
								prefix
								gender
								rate
								picture {
									urlThumb
								}
								medicEspecialities {
									id
									title
									university
									description
									price
									status
									especiality {
										name
									}
									medicSubespecialities {
										subespeciality {
											name
										}
									}
								}
							}
						}
					`,
					variables: {
						id: this.purchase.medic_id,
					},
				})
				.then((data) => {
					this.medic = data.data.medic
					this.loading = false
				})
		},

		confirmPurchase() {
			if (!this.purchasing) {
				this.saving = true

				let paymentValidate = { valid: false }

				if (this.purchase.coupon) {
					// si tengo cupon activo, valido el pago.
					paymentValidate.valid = true
				} else {
					paymentValidate = this.$refs.PaymentComponent.validate()
				}

				if (paymentValidate.valid) {
					this.purchasing = true

					let dataInput = {
						user_id: this.loggedUser.id,
						medic_id: this.purchase.medic_id,
						timeslot_id: this.purchase.slot.id,
						medic_especiality_id: this.purchase.especiality.id,
						medic_business_address_id: this.purchase.address.id,
						channel: this.purchase.channel,
						coupon: this.purchase.coupon,
						couponCode: this.purchase.couponCode,
					}

					this.$apollo
						.mutate({
							mutation: gql`
								mutation($data: BookingCreateInput!) {
									bookingCreate(data: $data) {
										id
										code
										user {
											name
											lastname
											email
											doc_type
											doc_number
										}
									}
								}
							`,
							variables: {
								data: dataInput,
							},
						})
						.then((data) => {
							this.bookingCode = data.data.bookingCreate.code
							if (this.purchase.coupon) {
								this.paymentDone(this.bookingCode, data.data.bookingCreate)
							} else {
								this.$refs.PaymentComponent.proccess(data.data.bookingCreate, 'booking')
							}
							this.$ga.event('users', 'booking-created', this.bookingCode)
						})
						.catch((error) => {
							console.log('error al crear la reserva.', error)
							this.purchasing = false
						})
				} else {
					this.saving = false
					this.$toast.error(paymentValidate.err)
				}
			}
		},

		paymentDone(bookingCode, data) {
			if (!bookingCode) {
				alert(data)
			} else {
				this.removePurchase()
				this.$router.push(`/checkout/${bookingCode}/payment`)
			}
			this.purchasing = false
		},

		paymentClosed(paying) {
			console.log('paymentClosed on Checkout detail', paying)

			this.removePurchase()
			this.purchasing = false
			this.$router.push('/checkout/' + this.bookingCode + '/payment')
		},
	},
}
</script>

<style scoped>
.booking .title {
	background-color: #12bcec;
	color: #fff;

	padding: 20px 30px;
	-webkit-border-radius: 5px 5px 0 0;
	-moz-border-radius: 5px 5px 0 0;
	-ms-border-radius: 5px 5px 0 0;
	border-radius: 5px 5px 0 0;
}
.booking .title h3 {
	font-size: 1.5rem;
	margin: 0;
	color: #fff;
}
.booking .title small {
	font-size: 13px;
	font-size: 0.8125rem;
}
.booking .summary {
	padding: 18px;
	margin: 0px;
	font-size: 14px;
}
.booking .summary ul {
	margin: 0px;
}
.booking .summary .total {
	font-size: 17px;
}
.booking hr {
	margin: 15px 0px;
}
.booking ul.treatments {
	padding: 18px;
}
.booking ul.treatments li {
	border-top: 1px dotted #ddd;
	border-bottom: none;
	width: 100%;
	margin: 0;
	padding: 12px 0 5px 0;
}
@media (max-width: 991px) {
	.booking ul.treatments li {
		/* For less than 991px */
		width: auto;
		float: none;
	}
}
</style>
